import React, { useState, useRef, useMemo, useEffect } from "react";
import { cleanAll } from "../../store/reducers/guestsReducer";
import { toast } from "react-toastify";
import FilledLoading from "../common/loader/FilledLoading";
import OpacityLoading from "../common/loader/OpacityLoading";
import { useSelector, useDispatch } from "react-redux";
import ClientRoutes from "../../navigation/Routes";
import {
  Button,
  FlexRowBetween,
  GenericDiv,
  Input,
  ListHolder,
  PlaceHolderImage,
  TextWithPic,
  TodoCard,
} from "../common/Style";
import ToolsOptions from "../user/ToolsOptions";
import GenericModal from "../common/modals/GenericModal";
import { useHistory } from "react-router-dom";
import LogoutSpecipic from "../common/LogOut/LogoutSpecipic";
import tools from "../../assets/common/menu.svg";
import logout from "../../assets/common/logout.svg";
import refresh from "../../assets/common/refresh.svg";
import BottomMenu from "../common/others/BottomMenu";
import CopyText from "../common/others/CopyText";
import { edit, getGuestAdmin } from "../../store/reducers/guestsReducer";
import EditGuest from "./EditGuest";
import clear from "../../assets/common/clear.svg";
import { useForm } from "react-hook-form";

const OptionalGuests2 = ({ phone }) => {
  const dispatch = useDispatch();
  const [showLoading, setShowLoading] = useState(false);
  const { guestsLoading, guests } = useSelector((state) => state.guestsReducer);
  let history = useHistory();
  const [showLogout, setShowLogout] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [guest2Edit, setGuest2Edit] = useState(null);

  useEffect(() => {
    dispatch(getGuestAdmin({ phone }));
    return () => {
      dispatch(cleanAll());
    };
  }, []);

  const handleEdit = (key, body) => {
    dispatch(edit(key, body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  let todosArray = useMemo(() => {
    let arr = [];
    if (Object.keys(guests).length > 0) {
      for (const [key, value] of Object.entries(guests))
        arr.push(
          <TodoCard
            key={key}
            onClick={() => setGuest2Edit({ value, key })}
            style={{ flexDirection: "column" }}
          >
            <FlexRowBetween>
              <div>M</div>
              <div
                style={{ padding: "4px 8px", border: "2px solid silver" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(key, {
                    accept: parseInt(0),
                    ans: "M",
                    notes: "טעות במספר",
                  });
                }}
              >
                טעות
              </div>
              <div
                style={{ padding: "4px 8px", border: "2px solid silver" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(key, { accept: parseInt(0), ans: "M" });
                }}
              >
                0
              </div>
              <div
                style={{ padding: "4px 8px", border: "2px solid silver" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(key, { accept: parseInt(1), ans: "M" });
                }}
              >
                1
              </div>
              <div
                style={{ padding: "4px 8px", border: "2px solid silver" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(key, { accept: parseInt(2), ans: "M" });
                }}
              >
                2
              </div>
            </FlexRowBetween>
            <FlexRowBetween
              style={{ marginTop: "15px" }}
            >{`${value.name}, ${value.accept}, ${value.uPhone}`}</FlexRowBetween>
            <FlexRowBetween style={{ marginTop: "15px" }}>
              <div>W</div>
              <div
                style={{ padding: "4px 8px", border: "2px solid silver" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(key, {
                    accept: parseInt(0),
                    ans: "W",
                    notes: "טעות במספר",
                  });
                }}
              >
                טעות
              </div>
              <div
                style={{ padding: "4px 8px", border: "2px solid silver" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(key, {
                    accept: parseInt(0),
                    ans: "W",
                  });
                }}
              >
                0
              </div>
              <div
                style={{ padding: "4px 8px", border: "2px solid silver" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(key, { accept: parseInt(1), ans: "W" });
                }}
              >
                1
              </div>
              <div
                style={{ padding: "4px 8px", border: "2px solid silver" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(key, { accept: parseInt(2), ans: "W" });
                }}
              >
                2
              </div>
            </FlexRowBetween>
          </TodoCard>
        );
    }
    return arr;
  }, [guests]);

  return (
    <div
      style={{
        width: "100%",
        height: `${window.screen.availHeight}px`,
      }}
    >
      <BottomMenu
        data={[
          <img
            key={2}
            src={tools}
            alt="tools"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowMenu(true)}
          />,
          <img
            key={3}
            src={logout}
            alt="logout"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowLogout(true)}
          />,
        ]}
      />
      <ListHolder>{todosArray}</ListHolder>
      <div style={{ height: "100px" }} />

      {showLoading && <FilledLoading />}
      {guestsLoading && <OpacityLoading />}
      {showLogout && (
        <GenericModal
          init={setShowLogout}
          div={<LogoutSpecipic init={setShowLogout} />}
        />
      )}

      {showMenu && (
        <GenericModal
          init={setShowMenu}
          div={
            <ToolsOptions
              data={[
                <TextWithPic
                  key={1}
                  onClick={() => history.push(ClientRoutes.Admin.main)}
                >
                  ראשי
                </TextWithPic>,
                // <TextWithPic
                //   onClick={() => history.push(ClientRoutes.Admin.todos)}
                //   key={2}
                // >
                //   משימות
                // </TextWithPic>,
              ]}
            />
          }
        />
      )}

      {guest2Edit && (
        <GenericModal
          init={setGuest2Edit}
          div={<EditGuest user={guest2Edit} init={setGuest2Edit} />}
        />
      )}
    </div>
  );
};

export default OptionalGuests2;
